import http from './http'

// 获取列表
export function pageList (data) {
  return http.get(`/user/article?${data}` )
}

// 获取评论列表
export function pageCommentList (data) {
  return http.get(`/user/article/comments?${data}` )
}

// 获取详情
export function getDetail (id) {
  return http.get(`/user/article/${id}`)
}

// 添加
export function add (data) {
  return http.post('/user/article', data)
}

// 编辑
export function edit (data) {
  return http.put(`/user/article/${data.Id}`, data)
}

// 编辑
export function editComment (data) {
  return http.put('/user/article/comment/edit', data)
}

// 删除
export function remove (id) {
  return http.delete(`/user/article/${id}`)
}

// 获取话题列表
export function getCategoryList () {
  return http.get('/web/article/category/tree/0')
}

export function uploadFile (data) {
  return http.post('/user/article/upload', data, {headers: {'Content-Type': 'multipart/form-data'}})
}
